export class IPRectangle {
  top: number;

  bottom: number;

  left: number;

  right: number;

  constructor(left?: number, right?: number, top?: number, bottom?: number) {
    this.left = left ?? 0;
    this.right = right ?? 0;
    this.top = top ?? 0;
    this.bottom = bottom ?? 0;
  }

  get width(): number {
    return this.right - this.left;
  }

  get height(): number {
    return this.bottom - this.top;
  }

  equals(rect: IPRectangle): boolean {
    const precision = 0.0001;

    return (
      Math.abs(this.left - rect.left) < precision &&
      Math.abs(this.right - rect.right) < precision &&
      Math.abs(this.top - rect.top) < precision &&
      Math.abs(this.bottom - rect.bottom) < precision
    );
  }
}
